module.exports = __webpack_public_path__ + "img/banner2.e9cc4d05.jpg";